import Api from '../../services/api_'

class Service extends Api {
    generate(reportName, reportParams) {
        const headers = {
            ...this._headers,
            'Accept': 'application/json',
            'Authorization': `Bearer ${this._token}`
        }

        const requestData = {
            url: `${this._baseUrl}/generate`,
            method: 'POST',
            headers: headers,
            data: { reportName, ...reportParams },
            responseType: 'arraybuffer'
        }

        return this._makeRequest(requestData)
    }
}

export default new Service('relatorio')